import ApiDocsRedirect from "view/api-documentation/ApiDocumentation";
import Dashboard from "view/dashboard/Dashboard";
import FreightForwarders from "view/freight-operators/FreightForwarders";
import IconsDisplay from "view/icons-display/IconsDisplay";
import Marketplace from "view/marketplace/Marketplace";
import OperationalActivity from "view/operational-activity/OperationalActivity";
import Setting from "view/setting/Setting";
import Trailers from "view/trailers/Trailers";
import Users from "view/user-management/Users";
import Vehicles from "view/vehicles/Vehicles";

const routes = [
  {
    path: "/",
    title: "Dashboard",
    component: Dashboard,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },
  {
    path: "/dashboard",
    title: "Dashboard",
    component: Dashboard,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },

  {
    path: "/activity-report",
    title: "Operational Activity",
    component: OperationalActivity,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },

  {
    path: "/freight-operators",
    title: "Freight Operators",
    component: FreightForwarders,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },

  {
    path: "/vehicles",
    title: "Vehicles",
    component: Vehicles,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },
  {
    path: "/trailers",
    title: "Trailers",
    component: Trailers,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },
  {
    path: "/Marketplace",
    title: "Marketplace",
    component: Marketplace,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },
  {
    path: "/system-settings",
    title: "System Settings",
    component: Setting,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },
  {
    path: "/user-management",
    title: "User Management",
    component: Users,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },
  {
    path: "/api-documentation",
    title: "Api Documentation",
    component: ApiDocsRedirect,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },
  {
    path: "/icons",
    title: "Icons",
    component: IconsDisplay,
    showFor: "all",
    hasPermission: (hasPermission) => hasPermission(true),
  },
];

export default routes;
